export function composeData({ repair_material, cost_per_item }) {
  const data = {
    modified_date: null,
    created_date: null,
    repair_material,
    quantity_used: 1,
    cost_per_item: parseFloat(cost_per_item).toFixed(2),
    total_cost: parseFloat(cost_per_item).toFixed(2),
  };

  return data;
}
